// ============================================================================
// THEME - Single Source of Truth for ALL Colors
// ============================================================================
// IMPORTANT: All color values across the application should reference this file.
// Do not hardcode color values in component files.
// ============================================================================
// CLASSIC THEME - Applied 2026-03-27
// ============================================================================

export const theme = {
  // Backgrounds
  bgPage: '#EAEAEA',
  bgSidebar: '#918C86',
  bgHeader: '#DED8D3',
  bgContent: '#EAEAEA',
  bgCard: '#FFFFFF',
  bgCardWarm: '#FFFFFF',
  bgSectionHeader: 'rgba(198,167,90,0.08)',
  bgTableHeader: '#FFFFFF',
  bgTableRow: '#FFFFFF',
  bgTableDivider: '#F5F3F0',
  bgInput: '#FFFFFF',
  bgTabRail: '#FFFFFF',
  bgToast: '#1A1A1A',

  // Sidebar - Gradient Depth Theme
  sidebarBg: 'linear-gradient(180deg, #1A1815 0%, #2D2925 100%)',
  sidebarActiveItem: 'rgba(255,255,255,0.08)',
  sidebarText: 'rgba(255,255,255,0.85)',
  sidebarActiveText: '#FFFFFF',
  sidebarSectionLabel: '#C6A75A',
  sidebarBorder: 'rgba(198,167,90,0.20)',
  sidebarBadgeBg: '#C6A75A',
  sidebarBadgeText: '#1A1815',
  sidebarActiveBorderLeft: '#C6A75A',
  sidebarSectionDivider: 'linear-gradient(90deg, rgba(198,167,90,0.40), transparent 80%)',

  // Text - IMPROVED CONTRAST FOR READABILITY
  textPrimary: '#1B1812',
  textSecondary: '#5A5348', // Darkened from #7A7367 for better readability
  textMuted: '#6B6358', // Darkened from #9B9385 for better readability
  textPlaceholder: '#8A8478', // Darkened from #A8A29E
  textLink: '#C6A75A',
  textInverse: '#FFFFFF',

  // Accent / Gold
  accentPrimary: '#C6A75A',
  accentHover: '#B89A4D',
  accentTintLight: 'rgba(198,167,90,0.08)',
  accentTintMedium: 'rgba(198,167,90,0.15)',

  // Borders
  borderLight: 'rgba(198,167,90,0.12)',
  borderMedium: 'rgba(198,167,90,0.18)',
  borderStrong: 'rgba(198,167,90,0.25)',
  borderInput: 'rgba(198,167,90,0.22)',
  borderInputFocus: '#C6A75A',

  // Buttons
  btnPrimaryBg: 'linear-gradient(135deg, #1B1812 0%, #2C2A26 100%)',
  btnPrimaryHover: 'linear-gradient(135deg, #2C2A26 0%, #3D3A35 100%)',
  btnPrimaryText: '#C6A75A',
  btnPrimaryBorder: 'rgba(198,167,90,0.40)',
  btnPrimaryShadow: '0 2px 8px rgba(0,0,0,0.10)',
  btnSecondaryBg: '#FFFFFF',
  btnSecondaryBorder: 'rgba(198,167,90,0.18)',
  btnSecondaryText: '#1B1812',
  btnDestructiveBg: '#EF4444',
  btnDestructiveText: '#FFFFFF',

  // Status (stoplight) - KEEP AS-IS
  statusSuccess: '#22A06B',
  statusSuccessTint: 'rgba(34,160,107,0.15)',
  statusWarning: '#f59e0b',
  statusWarningTint: 'rgba(245,158,11,0.15)',
  statusError: '#EF4444',
  statusErrorTint: 'rgba(239,68,68,0.15)',

  // Badges - KEEP AS-IS
  badgePendingBg: 'rgba(198,167,90,0.15)',
  badgePendingText: '#8A7847',
  badgeSuccessBg: 'rgba(34,160,107,0.15)',
  badgeSuccessText: '#22A06B',
  badgeErrorBg: 'rgba(220,38,38,0.15)',
  badgeErrorText: '#B24E4E',

  // Icons - KEEP AS-IS
  iconPrimary: '#C6A75A',
  iconMuted: '#7A7367',
  iconSuccess: '#22A06B',
  iconError: '#B24E4E',

  // Shadows - updated for warm depth
  shadowCard: '0px 6px 22px rgba(100,88,55,0.09), 0px 2px 6px rgba(100,88,55,0.05), inset 0px 1px 0px rgba(255,255,255,0.95)',
  shadowCardInset: 'inset 0px 1px 0px rgba(255,255,255,0.95)',

  // Tables
  tableRowHover: 'rgba(198,167,90,0.04)',
  tableRowSelected: 'rgba(198,167,90,0.08)',
  tableDivider: 'rgba(198,167,90,0.18)',

  // Chips/Tabs
  chipActiveBg: '#FFF4D7',
  tabActiveBorder: '#C6A75A',
};

// Default export for backwards compatibility
// Allows both: import C from '../../data/colors' AND import { theme } from '../../data/colors'
export default theme;
